import React, { useEffect, useState } from "react";
import { CompanyUsersAPI, ProjectAPI } from "./api/apiClient";
import { useNavigate } from "react-router-dom";
import { useUI } from "./context/UIContext";

export default function CompanyAddUser() {

  //const navigate = useNavigate();
 // const { setSelectedProjectId, setSelectedProjectName } = useUI();

  const navigate = useNavigate();
const { setSelectedProjectId, setSelectedProjectName, popUIState, pushUIState, setViewMode } = useUI();

  //const [companyUsers, setCompanyUsers] = useState<string[]>([]);
  const [companyUsers, setCompanyUsers] = useState<any[]>([]);

  const [assignProject, setAssignProject] = useState<any>(null);
const [assignUserEmail, setAssignUserEmail] = useState("");

 const [availableUsers, setAvailableUsers] = useState<string[]>([]);
  const [projects, setProjects] = useState<any[]>([]);
  const [selectedEmail, setSelectedEmail] = useState("");

  const [projectUsers, setProjectUsers] = useState<any[]>([]);
  const [selectedProject, setSelectedProject] = useState<any>(null);

  const [selectedRole, setSelectedRole] = useState("user");

  const [updateEmail, setUpdateEmail] = useState("");
const [updateRole, setUpdateRole] = useState("user");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // ✅ NEW STATE (PROJECT ASSIGN)
  //const [availableProjects, setAvailableProjects] = useState<any[]>([]);
  //const [selectedProjectIdAssign, setSelectedProjectIdAssign] = useState("");

  // 🔄 Load data
  const loadData = async () => {
    try {
      const projects = await CompanyUsersAPI.getCompanyProjects();
      setProjects(projects);
    } catch (err) {
      console.error("Projects error:", err);
    }

    try {
      const users = await CompanyUsersAPI.getCompanyUsers();
      const available = await CompanyUsersAPI.getAvailableUsers();

      setCompanyUsers(users);
      setAvailableUsers(available);
    } catch (err) {
      console.log("Not admin or no access");
    }
  };

  // ✅ LOAD AVAILABLE PROJECTS
 /* const loadAvailableProjects = async () => {
    try {
      const data = await CompanyUsersAPI.getAvailableProjects();
      setAvailableProjects(data);
    } catch {
      console.log("No available projects");
    }
  };*/

  useEffect(() => {
    loadData();
   // loadAvailableProjects(); // ✅ ADDED
   
  }, []);

  // ➕ Add User
  const handleAddUser = async () => {
    setError("");
    setMessage("");

    if (!selectedEmail) {
      setError("Select a user");
      return;
    }

    try {
      const res: any = await CompanyUsersAPI.addUser({
        email: selectedEmail,
       role: selectedRole, // ✅ ADD THIS
      });

      setMessage(res.message);
      setSelectedEmail("");
      loadData();
    } catch {
      setError("Failed to add user");
    }
  };

  const loadUserRole = async (email: string) => {
  if (!email) return;

  try {
    const res: any = await CompanyUsersAPI.getUserRole(email);
    setUpdateRole(res.role ?? "user");
  } catch (err: any) {
    setError(err.message || "Unable to load user role");
  }
};

/* const handleUpdateRole = async () => {
  if (!updateEmail) {
    setError("Select a user");
    return;
  }

  try {
    const res: any = await CompanyUsersAPI.updateUserRole({
      email: updateEmail,
      role: updateRole,
    });

    setMessage(res.message || "Role updated successfully");

    loadData();
    setUpdateEmail("");
    setUpdateRole("user");
  } catch (err: any) {
    setError(err.message || "Failed to update role");
  }
}; */
const handleUpdateRole = async () => {
  setError("");
  setMessage("");

  if (!updateEmail) {
    setError("Select a user");
    return;
  }

  // Get current user
  const currentUser = companyUsers.find(
    (u) => u.email === updateEmail
  );

  // If role is already the same, don't call the API
  if (
    currentUser &&
    currentUser.userType?.toLowerCase() === updateRole.toLowerCase()
  ) {
    setMessage(`User already has the '${updateRole}' role.`);
    return;
  }

  try {
    const res: any = await CompanyUsersAPI.updateUserRole({
      email: updateEmail,
      role: updateRole,
    });

    setMessage(res.message || "User role changed successfully.");

    loadData();
    setUpdateEmail("");
    setUpdateRole("user");
  } catch (err: any) {
    setError(err.message || "Failed to update role");
  }
};

/* const handleAssignUserToProject = async () => {
  if (!assignUserEmail) {
    setError("Select a user");
    return;
  }

  try {
    await CompanyUsersAPI.assignUserToProject({
      projectNo: assignProject.projectNo,
      email: assignUserEmail
    });

    setMessage("User assigned successfully");
    setAssignUserEmail("");
    setAssignProject(null);
  } catch {
    setError("Failed to assign user");
  }
};*/
// ✅ ONLY showing modified parts (clean & safe to replace)

const handleAssignUserToProject = async () => {
  if (!assignUserEmail) {
    setError("Select a user");
    return;
  }

  try {
    await CompanyUsersAPI.assignUserToProject({
      projectNo: assignProject.projectNo,
      email: assignUserEmail
    });

    setMessage("User assigned successfully");
    setAssignUserEmail("");

    // ✅ REFRESH PROJECT USERS
    handleProjectClick(assignProject);

    setAssignProject(null);
  } catch {
    setError("Failed to assign user");
  }
};

  // ❌ Remove User
 {/* const handleRemoveUser = async (email: string) => {
    setError("");
    setMessage("");

    try {
      await CompanyUsersAPI.removeUser({ email });
      setMessage("User removed successfully");
      loadData();
    } catch {
      setError("Failed to remove user");
    }
  };*/}
 const handleRemoveUser = async (email: string) => {
  setError("");

  try {
    const res: any = await CompanyUsersAPI.removeUser({ email });

    // ✅ FORCE message visible
    setMessage(res?.message || "User removed successfully");

    // ✅ delay reload
    setTimeout(() => {
      loadData();
    }, 1500);

  } catch (err: any) {
    setError(err.message || "Failed to remove user");
  }
};

  // ✅ ASSIGN PROJECT
  /*const handleAssignProject = async () => {
    setError("");
    setMessage("");

    if (!selectedProjectIdAssign) {
      setError("Select a project");
      return;
    }

    try {
      const res: any = await CompanyUsersAPI.assignProject(
        Number(selectedProjectIdAssign)
      );

      setMessage(res.message);
      setSelectedProjectIdAssign("");

      loadAvailableProjects(); // refresh dropdown
      loadData(); // refresh assigned projects
    } catch {
      setError("Failed to assign project");
    }
  };*/

  // 👥 VIEW PROJECT USERS
  const handleProjectClick = async (project: any) => {
    setSelectedProject(project);

    try {
      const users = await ProjectAPI.getUsers(project.projectNo);
      setProjectUsers(users);
    } catch (err) {
      console.error("Failed to load project users", err);
    }
  };

  return (
    <div className="h-screen overflow-y-auto bg-gray-100 p-6">

      {/* HEADER */}
      <div className="flex items-center mb-6">
        <button
          onClick={() => navigate(-1)}
        // onClick={() => popUIState()}
          className="mr-4 text-blue-600 font-semibold"
        >
          ←
        </button>

        <h1 className="text-2xl font-bold flex-1 text-center">
          Company SuperAdmin Dashboard
        </h1>

         {message && <p className="text-green-600 mt-4">{message}</p>}
      {error && <p className="text-red-500 mt-4">{error}</p>}
      </div>

      {/* 👥 COMPANY USERS */}
      <div className="bg-white p-6 rounded-xl shadow mb-6">
    

        <h2 className="text-lg font-semibold mb-3">Company Users</h2>

        {companyUsers.length === 0 && <p>No users found</p>}

        {/*{companyUsers.map((u, i) => (
          <div key={i} className="flex justify-between border p-2 mb-2 rounded">
            {u}
            <button
              onClick={() => handleRemoveUser(u)}
              className="text-red-500"
            >
              Remove
            </button>
          </div>
        ))}*/}
       
      {/*  {companyUsers.map((u, i) => (

  <div key={i} className="flex justify-between border p-2 mb-2 rounded">
    {u.email} 
    <button
      onClick={() => handleRemoveUser(u.email)} 
      className="text-red-500"
    >
      Remove
    </button>
  </div>*/}
   {companyUsers.map((u, i) => (
    <div
      key={i}
      className="flex flex-col sm:flex-row sm:justify-between sm:items-center border p-2 mb-2 rounded gap-2"
    >
      <span className="break-all">{u.email}</span>

      <button
        onClick={() => handleRemoveUser(u.email)}
        className="text-red-500 text-sm sm:text-base"
      >
        Remove
      </button>
    </div>

  
))}
      </div>

      {/* ➕ ADD USER */}
      <div className="bg-white p-6 rounded-xl shadow mb-6">
        <h2 className="text-lg font-semibold mb-3">Add User</h2>

        {/*<select
          value={selectedEmail}
          onChange={(e) => setSelectedEmail(e.target.value)}
          className="w-full border p-2 rounded mb-3"
        >
          <option value="">Select User</option>
          {availableUsers.map((u, i) => (
            <option key={i} value={u}>{u}</option>
          ))}
        </select>*/}
        <input
  type="email"
  value={selectedEmail}
  onChange={(e) => setSelectedEmail(e.target.value)}
  placeholder="Enter user email"
  className="w-full border p-2 rounded mb-3"
/>

{availableUsers.some(
  (u) => u.toLowerCase() === selectedEmail.toLowerCase()
) && (
  <select
    value={selectedEmail}
    onChange={(e) => setSelectedEmail(e.target.value)}
    className="w-full border p-2 rounded mb-3"
  >
    {availableUsers
      .filter(
        (u) =>
          u.toLowerCase() === selectedEmail.toLowerCase()
      )
      .map((u, i) => (
        <option key={i} value={u}>
          {u}
        </option>
      ))}
  </select>
)}
       
        <select
  value={selectedRole}
  onChange={(e) => setSelectedRole(e.target.value)}
  className="w-full border p-2 rounded mb-3"
>
   <option value="superadmin">SuperAdmin</option>
   <option value="admin">Admin</option>
  <option value="user">Normal User</option>
  <option value="client">Client</option>
 
</select>

        <button
          onClick={handleAddUser}
          className="w-full bg-green-600 text-white py-2 rounded"
        >
          Add User
        </button>
      </div>

      <div className="bg-white p-6 rounded-xl shadow mb-6">
  <h2 className="text-lg font-semibold mb-3">
    Update User Role
  </h2>

  <select
    value={updateEmail}
    onChange={async (e) => {
      const email = e.target.value;
      setUpdateEmail(email);

      if (email) {
        await loadUserRole(email);
      }
    }}
    className="w-full border p-2 rounded mb-3"
  >
    <option value="">Select User</option>

    {companyUsers.map((u, i) => (
      <option key={i} value={u.email}>
        {u.email}
      </option>
    ))}
  </select>

  <select
    value={updateRole}
    onChange={(e) => setUpdateRole(e.target.value)}
    className="w-full border p-2 rounded mb-3"
  >
    <option value="superadmin">SuperAdmin</option>
    <option value="admin">Admin</option>
    <option value="user">User</option>
  </select>

  <button
    onClick={handleUpdateRole}
    className="w-full bg-blue-600 text-white py-2 rounded"
  >
    Update Role
  </button>
</div>

      {/* ✅ ASSIGN PROJECT (NEW UI) */}
     {/* <div className="bg-white p-6 rounded-xl shadow mb-6">
        <h2 className="text-lg font-semibold mb-3">Assign Project</h2>

        <select
          value={selectedProjectIdAssign}
          onChange={(e) => setSelectedProjectIdAssign(e.target.value)}
          className="w-full border p-2 rounded mb-3"
        >
          <option value="">Select Project</option>

          {availableProjects.map((p) => (
            <option key={p.projectNo} value={p.projectNo}>
              {p.projectName}
            </option>
          ))}
        </select>

        <button
          onClick={handleAssignProject}
          className="w-full bg-blue-600 text-white py-2 rounded"
        >
          Assign Project
        </button>
      </div> */}

      {/* 📁 MY PROJECTS */}
     {/* <div className="bg-white p-6 rounded-xl shadow">
        <h2 className="text-lg font-semibold mb-3">Company  Projects</h2>*/}

        <div className="bg-white p-6 rounded-xl shadow">

  <div className="flex justify-between items-center mb-3">
    <h2 className="text-lg font-semibold">Company Projects</h2>

    <button
      onClick={() => {
        if (projects.length === 0) {
          setError("No projects available");
          return;
        }

        const p = projects[0];
        setSelectedProjectId(p.projectNo);
        setSelectedProjectName(p.projectName);
        navigate("/");
      }}
      className="bg-green-600 text-white px-4 py-1 rounded text-sm"
    >
      Open the Projects Page
    </button>
  </div>


        {projects.length === 0 && <p>No projects assigned</p>}

       {/* {projects.map((p) => (
          <div
            key={p.projectNo}
            className="flex justify-between items-center border p-3 mb-2 rounded"
          >
            <span>{p.projectName}</span>

            <div className="flex gap-3">
              <button
                onClick={() => {
                 
                  setSelectedProjectId(p.projectNo);
                  setSelectedProjectName(p.projectName);
                  navigate("/");

                

                }}
                className="text-green-600 font-semibold"
              >
                Open
              </button>

              <button
                onClick={() => handleProjectClick(p)}
                className="text-blue-600 underline"
              >
                See Users
              </button>

              <button
  onClick={() => setAssignProject(p)}
  className="text-purple-600 underline"
>
  Assign User
</button>
            </div>
          </div>
        ))}*/}
        
       {/* {projects.map((p) => (
  <div
    key={p.projectNo}
    className="flex flex-col sm:flex-row sm:justify-between sm:items-center border p-3 mb-2 rounded gap-2"
  >
    
    <span className="break-words font-medium">
      {p.projectName}
    </span>

    
    <div className="flex flex-wrap gap-2">
     

      <button
        onClick={() => handleProjectClick(p)}
        className="text-blue-600 underline text-sm"
      >
        See Users
      </button>

    
      <button
  onClick={async () => {
    setAssignProject(p);

    try {
      const users = await ProjectAPI.getUsers(p.projectNo);
      setProjectUsers(users);
    } catch (err) {
      console.error("Failed to load project users", err);
    }
  }}
  className="text-purple-600 underline text-sm"
>
  Assign User
</button>
    </div>
  </div>
))} */}

{projects.map((p) => (
  <div
    key={p.projectNo}
    className="border p-3 mb-3 rounded bg-white shadow"
  >
    {/* TOP */}
    <div className="flex justify-between items-center">
      <span className="font-medium">{p.projectName}</span>

      <div className="flex gap-3">
        {/* SEE USERS */}
        <button
          onClick={() => {
            setAssignProject(null);
            handleProjectClick(p);
          }}
          className="text-blue-600 underline text-sm"
        >
          See Users
        </button>

        {/* ASSIGN USER */}
        <button
          onClick={async () => {
            setSelectedProject(null);
            setAssignProject(p);

            const users = await ProjectAPI.getUsers(p.projectNo);
            setProjectUsers(users);
          }}
          className="text-purple-600 underline text-sm"
        >
          Assign User
        </button>
      </div>
    </div>

    {/* 👇 USERS INSIDE CARD */}
    {selectedProject?.projectNo === p.projectNo && (
      <div className="mt-4 border-t pt-3">
        <h3 className="font-semibold mb-2">Users</h3>

        {projectUsers.map((u, i) => (
          <div key={i} className="flex justify-between mb-2">
            <span>{u.email}</span>

            <button
              onClick={async () => {
                await CompanyUsersAPI.removeUserFromProject({
                  projectNo: p.projectNo,
                  email: u.email
                });
                handleProjectClick(p);
              }}
              className="text-red-500 text-sm"
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    )}

    {/* 👇 ASSIGN INSIDE CARD */}
    {assignProject?.projectNo === p.projectNo && (
      <div className="mt-4 border-t pt-3">
        <h3 className="font-semibold mb-2">Assign User</h3>

        <select
          value={assignUserEmail}
          onChange={(e) => setAssignUserEmail(e.target.value)}
          className="w-full border p-2 rounded mb-2"
        >
          <option value="">Select User</option>

          {companyUsers
            .filter(u => u.userType?.toLowerCase() === "user")
            .filter(u => !projectUsers.some(pu => pu.email === u.email))
            .map((u, i) => (
              <option key={i} value={u.email}>
                {u.email}
              </option>
            ))}
        </select>

        <button
          onClick={handleAssignUserToProject}
          className="w-full bg-purple-600 text-white py-2 rounded"
        >
          Assign
        </button>
      </div>
    )}
  </div>
))}

      </div>

     {/* {assignProject && (
  <div className="bg-white p-6 rounded-xl shadow mt-6">
    <h2 className="text-lg font-semibold mb-3">
      Assign User to {assignProject.projectName}
    </h2>

    <select
      value={assignUserEmail}
      onChange={(e) => setAssignUserEmail(e.target.value)}
      className="w-full border p-2 rounded mb-3"
    >
      <option value="">Select User</option>

    
        {companyUsers
  .filter(u => u.userType?.toLowerCase() === "user")
  // ✅ ADD THIS LINE
  .filter(u => !projectUsers.some(pu => pu.email === u.email))
  .map((u, i) => (
          <option key={i} value={u.email}>
            {u.email}
          </option>
        ))}
    </select>

    <button
      onClick={handleAssignUserToProject}
      className="w-full bg-purple-600 text-white py-2 rounded"
    >
      Assign User
    </button>
  </div>
)} */}

      {/* 👥 PROJECT USERS */}
    {/*  {selectedProject && (
        <div className="bg-white p-6 rounded-xl shadow mt-6">
          <h2 className="text-lg font-semibold mb-3">
            Users in {selectedProject.projectName}
          </h2>

         
{projectUsers.map((u, i) => (
  <div
    key={i}
    className="flex flex-col sm:flex-row sm:justify-between sm:items-center border p-2 mb-2 rounded gap-2"
  >
    <div className="break-all">
      <div className="font-medium">
        {u.userName || u.email}
      </div>
      <div className="text-sm text-gray-500">
        {u.email}
      </div>
    </div>

    <button
      onClick={async () => {
        try {
          await CompanyUsersAPI.removeUserFromProject({
            projectNo: selectedProject.projectNo,
            email: u.email
          });

          setMessage("User removed from project");
          handleProjectClick(selectedProject);
        } catch {
          setError("Failed to remove user");
        }
      }}
      className="text-red-500 font-semibold text-sm sm:text-base"
    >
      Remove
    </button>
  </div>
))} */}

              {/*{u.isAssigned ? (
                <span className="text-green-600 font-semibold">
                  Assigned
                </span>
              ) : (
                <span className="text-gray-400">
                  Not Assigned
                </span>
              )}*/}
          {/*  </div> 
         // ))}
       // </div>
      )}

      {/* MESSAGES */}
     
    </div>
  );
}